import React from 'react';
import PropTypes, { object } from 'prop-types';
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import CustomTooltip from './CustomTooltip/CustomTooltip';

import { tick } from '../helpers/config';
import { textToDateM } from 'utils/common';

const Chart = ({ data, config }) => {
  const formatter = value => (value !== 'auto' ? textToDateM(value) : '');

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart
        data={data}
        margin={{
          top: 8,
          right: 0,
          left: -24,
          bottom: -12
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="date"
          tick={tick}
          axisLine={false}
          tickLine={false}
          padding={{ left: 64, right: 64 }}
          tickFormatter={formatter}
        />
        <YAxis
          tickCount={5}
          scale="linear"
          domain={[
            0,
            dataMax =>
              dataMax
                ? Math.ceil(dataMax * 1.1) +
                  (5 - (Math.ceil(dataMax * 1.1) % 5))
                : 100
          ]}
          tick={tick}
          axisLine={false}
          tickLine={false}
        />

        {data.length !== 0 && <Tooltip content={<CustomTooltip />} />}

        {config.map(item => {
          return item.type === 'area' && item.value === true ? (
            <Area
              dataKey={item.name}
              key={item.name}
              fill={item.color}
              stroke={item.color}
              activeDot={!item.invisible ? true : false}
              fillOpacity={1}
            />
          ) : item.type === 'line' && item.value === true ? (
            <Line
              strokeWidth={2}
              key={item.name}
              dataKey={item.name}
              stroke={item.color}
              dot={false}
            />
          ) : null;
        })}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

Chart.propTypes = {
  data: PropTypes.arrayOf(object),
  config: PropTypes.array
};

export default Chart;
